import { render, staticRenderFns } from "./TotalesPorPartida.vue?vue&type=template&id=78a5e10a"
import script from "./TotalesPorPartida.vue?vue&type=script&lang=js"
export * from "./TotalesPorPartida.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports